import { useToast } from 'vue-toastification'
import AlertNotification from '../../components/Flashes/AlertNotification.vue'

let toastI = 0
let toast = null

export default function (type, heading, message, timeout) {
  if (toast === null) {
    toast = useToast()
  }

  const toastId = 'toast' + (toastI++)
  const toastConfig = { id: toastId, type }
  if (timeout !== undefined) {
    if (timeout === false) {
      toastConfig.timeout = false
      toastConfig.draggable = false
      toastConfig.closeOnClick = false
    
    } else {
      toastConfig.timeout = timeout
    }
  }

  toast(
    {
      component: AlertNotification,
      props: {
        alert: type,
        heading,
        message,
        toastId
      },
      listeners: {}
    },
    toastConfig  
  )

  return {
    dismiss() {
      toast.dismiss(toastId)
    }
  }
}